<template name="footer-info">
  <footer class="footer">
    <div class="container">
      <nav class="navbar fixed-bottom navbar-light bg-light">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link disabled">
              Lomas, Briggs, Maguire, VSW
              <small>and the NW School of Anaesthesia</small>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<style scoped>
li {
  padding-left: 10px !important;
}
footer {
  margin-top: 100px !important;
}
</style>